<mat-button-toggle-group #group="matButtonToggleGroup" (change)="onChange(group.value)" [value]="this.selectedLanguage">
  @for (language of languages; track language.code) {
    @if (!isHidden(language.code)) {
      <mat-button-toggle
        [value]="language"
        [disabled]="isDisabled(language.code)"
        [aria-label]="language.name">
        <flag [countryCode]="language.flag" [class.mark_as_empty]="markAsEmpty(language.code)"></flag>
      </mat-button-toggle>
    }
  }
</mat-button-toggle-group>
